module.exports = __webpack_public_path__ + "img/thumbnail01.2902478e.jpg";